import { fetchWrapper } from "@/helpers"
import { defineStore } from "pinia"
import { nextTick } from "vue"

const baseUrl = process.env.VUE_APP_PROXY_SERVER + "/api/SLA"

export const useSLAStore = defineStore(`${process.env.VUE_APP_NAME}_slaStore`, {
  id: "slas",
  state: () => ({
    SLA: [],
    lastUpdateSLA: "",
  }),
  persist: true,
  actions: {
    async fetchSLA(refresh = false) {
      if (refresh || this.SLA.length == 0) {
        var allSLA = await fetchWrapper.get(`${baseUrl}/All`)

        this.SLA = allSLA.data
        this.lastUpdateSLA = allSLA.lastUpdate
      }
    },
    async getDataSLA() {
      return this.SLA
    },
    async checkUpdateSLA() {
      var lastUpdate = await fetchWrapper.get(`${baseUrl}/LastUpdate`)

      return lastUpdate == this.lastUpdateSLA
    },
  },
})
